import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function VerifyTick() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-[11px] h-[11px]">
      <path d="M9 16.2l-3.5-3.5L4 14.2 9 19 20 8l-1.5-1.5z" />
    </svg>
  );
}

/**
 * OwnerBand
 *
 * Pill card: owner avatar (mono initial) + "Curated by <owner>",
 * verified / fulfilled line, and a "Meet the owner" link to About.
 *
 * @param {string} [ownerName] - Owner first name, e.g. "Meera"
 */
export default function OwnerBand({ ownerName = "Meera" }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const initial = (ownerName || "M").trim().charAt(0).toUpperCase();

  return (
    <div className="flex items-center gap-[10px] mx-4 my-[12px] px-[12px] py-[8px] bg-white border border-wc-border rounded-pill shadow-[0_4px_18px_rgba(31,33,46,.08)] lg:mx-0 lg:my-0 lg:order-1 lg:flex-1 lg:basis-1/2 lg:rounded-lg lg:px-[16px] lg:py-[12px] lg:shadow-none">
      <div className="w-[34px] h-[34px] flex-none rounded-full bg-s-primary text-white grid place-items-center font-[500] text-[14px] leading-none">
        {initial}
      </div>
      <div>
        <div className="text-[12.5px] font-[500] text-ink-900">
          {t("ownerBand.curatedBy", { name: ownerName })}
        </div>
        <div className="inline-flex items-center gap-[4px] text-[10px] font-[400] text-verify mt-[2px]">
          <VerifyTick /> {t("ownerBand.verified")}
        </div>
      </div>
      <button
        type="button"
        onClick={() => navigate("/about")}
        className="ml-auto text-[11px] font-[500] text-s-primary flex-none"
      >
        {t("ownerBand.meetOwner")}
      </button>
    </div>
  );
}
